import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
// services
import { MessageService } from '../../../../services/message.service';
import { MasterService } from '../../../../services/master.service';
import { StoreService } from '../../../../services/store.service';
import * as words from '../../../../services/language'

@Component({
    selector: 'gps-devices-modal',
    templateUrl: './gps-devices-modal.component.html',
    styleUrls: ['./gps-devices-modal.component.scss'],
    standalone: false
})
export class GpsDevicesModal implements OnInit, OnChanges {
    /*
    * variables
    */
    
    // The vehicle whose gps devices will be listed.
    @Input() vehicleId: number = 0
    
    // Currently selected language
    @Input() language: string = localStorage.getItem('language') ? localStorage.getItem('language') : 'EN'
    
    // Word replacements for each language.
    @Input() words: Object = words.language

    // A list of gps devices for the given vehicle.
    protected devices: Array<any> = []
    
    // Indicates whether the data is currently loading.
    protected loading: boolean = false

    constructor(private master: MasterService, private ms: MessageService, private store: StoreService) { }

    ngOnInit() {
        this.reset()
        this.fetch()
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes) {
            return
        }

        const first = Object.values(changes).some(c => c.isFirstChange())
        if (first) {
            return
        }

        if (changes.vehicleId) {
            this.reset()
            this.fetch()
        }
    }
    
    /*
    * functions
    */

    /**
     * 
     * @param e 
     */
    protected cancel = (e: Event): void => {
        e.stopPropagation()
        e.preventDefault()

        this.reset()
    }

    /*
    * Reset the devices array
    */
    private reset = (): void => {
        this.devices = null
    }

    /**
     * 
     */
    private fetch() {
        if (this.loading) {
            return
        }

        if (!this.vehicleId || (this.vehicleId <= 0)) {
            return
        }

        this.devices = null
        this.devices = []

        this.master.get(`vehicles/${this.vehicleId}/gps`, (res) => {
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }
  
            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            const assignments = res.data.GPSInventoryAssignment
            for (const assignment of assignments) {
                const meta = {
                    location: assignment.deviceLocation,
                    installer: assignment.installedBy,
                    product: null,
                    serial: null,
                    company: null,
                    category: null,
                    description: null,
                    status: null,
                    vehicle: null,
                    vin: null,
                    url: null
                }

                if (assignment.gpsDevice && assignment.gpsDevice.id) {
                    meta.product = assignment.gpsDevice.productName
                    meta.serial = assignment.gpsDevice.serialNumber
                    meta.status = assignment.gpsDevice.status

                    if (assignment.gpsDevice.integrationCompany && assignment.gpsDevice.integrationCompany.id) {
                        meta.company = assignment.gpsDevice.integrationCompany.name
                        meta.category = assignment.gpsDevice.integrationCompany.category
                        meta.description = assignment.gpsDevice.integrationCompany.description
                        meta.url = assignment.gpsDevice.integrationCompany.url
                    }
                }

                if (assignment.vehicle && assignment.vehicle.id) {
                    meta.vehicle = `${assignment.vehicle.modelYear} ${assignment.vehicle.make} ${assignment.vehicle.model}`
                    meta.vin = assignment.vehicle.vinNumber
                }
                
                this.devices.push(meta)
            }
            
            
        })
    }
}
